import React, {useEffect, useState} from "react";
// import Select from 'react-select'
import "./pphero.scss";

import {useHistory} from "react-router-dom";
import Button from "../../../../components/button/Button.jsx";
import {useCountryContextContext} from "../../../../hooks/CountryContext";
import PriceData from "./priceData..json";
import CountrySelection from "../../../../components/countrySelection/CountrySelection";


const PPHero = () => {
    const selectedCountry = useCountryContextContext();
    const [countryDataPrice, setCountryDataPrice] = useState([]);
    useEffect(() => {
        const currentCountryPriceData = PriceData.filter((obj) =>
            obj.country.toLocaleLowerCase() === selectedCountry.country.value.toLocaleLowerCase());

        setCountryDataPrice(currentCountryPriceData[0]?.data)
    }, [selectedCountry.country, setCountryDataPrice])

    return (
        <div className="pphero">
            <div className="pphero__bg_filter"/>
            <div className="pphero__wrapper">
                <h1 className="primary__heading">Start saving thousands.</h1>
                <p>Choose the plan that fits your business best:</p>

                <CountrySelection/>

                <div className="pphero__wrapper__items">
                    {countryDataPrice.map(
                        ({
                             heading,
                             description,
                             price, items,
                             link,
                             button_text,
                             type,
                             ...rest
                         },
                         index) => (
                            <PlanItem
                                key={index}
                                heading={heading}
                                description={description}
                                price={price}
                                items={items}
                                link={link}
                                otherProps={rest}
                                buttonText={button_text}
                                country={selectedCountry.country.value}
                                type={type}
                            />
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

const PlanItem = ({
                      heading = "",
                      price = 0,
                      description = "",
                      items = [],
                      link,
                      otherProps,
                      buttonText,
                      type
                  }) => {
    const {most_popular} = otherProps;
    const history = useHistory();

    return (
        <div
            className={[
                "price_container",
                most_popular === true ? "most_popular" : null,
            ].join(" ")}
        >
            <div className="price_container__wrapper">
                <div>
                    <h2 className="secondary__heading">{heading}</h2>
                    <span>{price}</span>
                    <p>{description}</p>
                    <div className="price_container__wrapper__items">
                        {items.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </div>
                </div>
                <div className="buttom_container">
                    <Button
                        onclick={() => {
                            buttonText === "Get Started" ?
                                history.push({
                                    pathname: `/${link}`,
                                    state: {type: "jamaica", subtype: type},
                                }) : history.push(`/${link}`);

                        }}
                        text={buttonText}
                        type="primary"
                    />
                </div>
            </div>
        </div>
    );
};

export default PPHero;
